import moment from 'moment'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { SingleDatePicker } from 'react-dates'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import { breakpoints } from '../../constants/breakpoits.constants'
import HigherOrderField from './higher-order-field.component'
import './styles/react_dates_overrides.scss'

/**
 *
 * @class DatepickerInput
 * @extends {Component}
 *
 * @param {string} date
 * format DD/MM/AAAA
 *
 * @param {string} id
 * Formik to be able to handle state
 *
 * @param {boolean} showClearDate
 * Defines if user can clear the selected date
 */
export class DatepickerInput extends Component {
	constructor(props) {
		super(props)
		moment.locale('pt-br')
		const { id, values, elementRef, date } = props

		let value = null
		if (date) value = moment(date, 'DD/MM/YYYY')
		else value = values[id] ? moment(values[id], 'DD/MM/YYYY') : null

		this.elementRef = elementRef || React.createRef()
		this.state = {
			date: value,
			focused: null,
			width: window.innerWidth,
		}
	}

	componentWillMount() {
		window.addEventListener('resize', this.handleWindowSizeChange)
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleWindowSizeChange)
	}

	componentDidMount() {
		setTimeout(() => {
			const { date } = this.state
			if (!!date) {
				const { id, setFieldValue } = this.props
				setFieldValue(id, date.format('YYYY-MM-DD'))
			}
		}, 0)
	}

	handleWindowSizeChange = () => {
		this.setState({ width: window.innerWidth })
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.date !== nextProps.date) {
			this.changeValue(moment(nextProps.date, 'DD/MM/YYYY'))
		}
	}

	changeValue = (date) => {
		const { id, setFieldValue } = this.props
		this.setState({
			date,
		})
		setFieldValue(
			id,
			date && date.isValid() ? date.format('YYYY-MM-DD') : null
		)
	}

	handleChange = (date) => {
		const newValue = date
			? date instanceof moment
				? date
				: moment(date)
			: null
		const { onValueChange } = this.props
		this.changeValue(newValue)
		onValueChange && onValueChange(newValue)
	}

	render() {
		const {
			id,
			icon,
			disabled,
			placeholder,
			openDirection,
			showClearDate,
			isOutsideRange,
		} = this.props
		const isMobile = this.state.width <= breakpoints.MOBILE

		return (
			<HigherOrderField innerRef={this.elementRef} {...this.props}>
				<SingleDatePicker
					id={id}
					noBorder
					readOnly
					block={true}
					numberOfMonths={1}
					disabled={disabled}
					ref={this.elementRef}
					withPortal={isMobile}
					date={this.state.date}
					inputIconPosition="after"
					displayFormat="DD/MM/YYYY"
					showDefaultInputIcon={icon}
					focused={this.state.focused}
					openDirection={openDirection}
					showClearDate={showClearDate}
					onDateChange={this.handleChange}
					hideKeyboardShortcutsPanel={true}
					placeholder={placeholder || 'Selecione ...'}
					isOutsideRange={(value) =>
						isOutsideRange && isOutsideRange(value)
					}
					onFocusChange={({ focused }) => {
						this.setState({ focused })
						if (focused) {
							const selects = [
								...document.querySelectorAll('[id^="field-"]'),
							]
							selects.forEach((elem) => {
								if (elem.id != `field-${id}`) {
									elem.style.zIndex = 0
								}
							})
						} else {
							const selects = [
								...document.querySelectorAll('[id^="field-"]'),
							]
							selects.forEach((elem) => {
								elem.style.zIndex = 'auto'
							})
						}
					}}
				/>
			</HigherOrderField>
		)
	}
}

DatepickerInput.propTypes = {
	id: PropTypes.string.isRequired,
}

export default DatepickerInput
